import React from "react";

import  "./PrevChatLoader.css";

import { Spinner } from "reactstrap";

export interface IPrevChatLoaderProps {
    gettingPrevChat: boolean,
    onGetPrevChatClicked: () => void
}

const PrevChatLoader = (props: IPrevChatLoaderProps) => {
    return (
        <div className="load-prev-chat-container">
            {props.gettingPrevChat ? 
                <span className="load-prev-chat-spinner"><Spinner style={{ width: '1rem', height: '1rem' }} /></span> :
                <span onClick={props.onGetPrevChatClicked} className="load-prev-chat-image"><img></img></span>
            }
        </div>
    );
}

export default PrevChatLoader;